{
  "assetContainerEvent": {
    "types": {
      "arrived": "Tiba",
      "arrivedWaiting": "Tiba/Menunggu",
      "loading": "Memuat",
      "loadingComplete": "Pemuatan Selesai",
      "unloading": "Membongkar",
      "unloadingComplete": "Pembongkaran Selesai",
      "readyForPickup": "Siap Diambil",
      "departed": "Berangkat",
      "inoperable": "Tidak Dapat Dioperasikan",
      "missing": "Hilang",
      "inTransit": "Dalam Perjalanan"
    }
  },
  "assetVisitYardEvent": {
    "Arrived": "Tiba",
    "Docked": "Merapat di Dok",
    "Parked": "Diparkir",
    "Unassigned": "Belum Ditetapkan",
    "Dropped": "Dilepas",
    "Hooked": "Disambungkan",
    "Appointment Linked": "Janji Temu Ditautkan",
    "Appointment Unlinked": "Tautan Janji Temu Dilepas",
    "Status Updated": "Pembaruan Status"
  },
  "assetContainerTypes": {
    "trailer": "Trailer",
    "container": "Kontainer",
    "oversized": "Berukuran besar",
    "chassis": "Sasis",
    "reefer": "Reefer (Berpendingin)",
    "other": "Lainnya"
  },
  "assetVisitTypes": {
    "live": "Langsung (Live)",
    "drop": "Lepas (Drop)",
    "pickup": "Sambung (Hook)",
    "dropHook": "Lepas & Sambung"
  },
  "assetVisitDirections": {
    "inbound": "Masuk",
    "outbound": "Keluar",
    "inboundAndOutbound": "Masuk & Keluar"
  },
  "loadTypeDirections": {
    "inbound": "Masuk",
    "outbound": "Keluar",
    "inOut": "Masuk & Keluar"
  },
  "altAssetVisitTypes": {
    "unknown": "Tidak diketahui"
  },
  "assetContainerStates": {
    "full": "Penuh",
    "empty": "Kosong",
    "partiallyLoaded": "Terisi Sebagian"
  },
  "spotStatuses": {
    "open": "terbuka",
    "closed": "tertutup",
    "assigned": "ditetapkan",
    "inTransit": "dalam perjalanan",
    "reservedManual": "direservasi",
    "reservedAutomated": "direservasi",
    "unknown": "tidak diketahui"
  },
  "spotTypes": {
    "parking": "parkir",
    "docking": "dok"
  },
  "labels": {
    "licensePlate": "Pelat Nomor",
    "dotNumber": "Nomor DOT"
  },
  "messages": {
    "unknownCompany": "Perusahaan Tidak Dikenal",
    "unhooked": "Tidak Tersambung",
    "noInformationAvailable": "Tidak ada informasi tersedia",
    "noVisitFound": "Tidak ada kunjungan ditemukan",
    "notInformed": "Tidak diinformasikan",
    "waitingAssignment": "Menunggu penugasan",
    "failedToLoadSpotDetails": "Gagal memuat detail petak",
    "retry": "Coba lagi",
    "blockedUntilSpotIsOpen": "Diblokir hingga {spot} terbuka",
    "blockReasons": {
      "reservedByOther": "Petak tujuan **direservasi** untuk **Tugas Pindah #{taskNumber}**.",
      "reservedByOtherGeneric": "Petak tujuan **direservasi**.",
      "destinationClosed": "Petak tujuan **tertutup**.",
      "destinationOccupied": "Petak tujuan **terisi** oleh aset lain.",
      "anotherAssetInTransitForDestination": "**{assetCode}** sudah dalam perjalanan ke petak ini.",
      "assetInTransitElsewhere": "Aset sudah dipindahkan oleh tugas pindah lain."
    }
  }
}
